export default __webpack_public_path__ + "static/media/D1S_Black.ea9d29c5.png";